import { useState } from 'react'

// The Eizel "E" app icon, served from public/. Used as the lead-image fallback
// so every row keeps the same layout whether or not it has an image.
const PLACEHOLDER_SRC = '/apple-touch-icon.png'

interface RowThumbnailProps {
  imageUrl?: string | null
  /** Existing thumbnail class that sizes the tile (e.g. discover-thumb / article-card-thumb). */
  className?: string
}

/**
 * Fixed-size lead-image tile shared by the Discover feed and the Saved list.
 *
 * Mirrors the iOS RowThumbnail: when an item has no image — or the image fails
 * to load — it falls back to the Eizel app logo instead of collapsing, so rows
 * stay aligned regardless of whether their source provided an image.
 */
export function RowThumbnail({ imageUrl, className }: RowThumbnailProps) {
  const [failed, setFailed] = useState(false)
  const usePlaceholder = !imageUrl || failed

  return (
    <img
      src={usePlaceholder ? PLACEHOLDER_SRC : imageUrl!}
      alt=""
      className={className}
      loading="lazy"
      // Fall back to the logo on a broken image rather than hiding the tile.
      onError={() => setFailed(true)}
    />
  )
}
